import {
  HTTP_GETFORECASTLIST3_FETCHING,
  HTTP_GETFORECASTLIST3_SUCCESS,
  HTTP_GETFORECASTLIST3_FAILED,
  HTTP_RESET_FORECASTLIST3,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETFORECASTLIST3_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETFORECASTLIST3_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETFORECASTLIST3_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    case HTTP_RESET_FORECASTLIST3:
      return initialState;
    default:
      return state;
  }
};
